//This page displays all the workers belonging to a user 
import {useState, useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {getWorkers } from  '../features/workers/workerSlice'

import Spinner from '../components/Spinner'
import WorkerItem from '../components/WorkerItem'
import {FiSearch, FiUserPlus} from 'react-icons/fi'
import { reset, resetWorkersMessage } from '../features/workers/workerSlice'; 
import { reset as resetSelectedWorker} from '../features/selectedWorker/selectedWorkerSlice'
import { useSubStatus } from '../hooks/useSubStatus';
import { toast } from 'react-toastify';
function Workers() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { workers, isLoading, message } = useSelector((state) => state.workers);
    const { subStatus } = useSubStatus(); // Get subscription status

    const [searchTerm, setSearchTerm] = useState("");

    const filterWorkers = (searchTerm) => {
        return Array.isArray(workers)
            ? workers.filter(
                  (worker) =>
                      worker.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                      worker.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                      worker.phone.includes(searchTerm)
              )
            : [];
    };

    
    useEffect(() => {
        dispatch(getWorkers());
        dispatch(resetSelectedWorker());
    }, [dispatch]);

    useEffect(() => {
        if (message) {
            toast(message);
            dispatch(resetWorkersMessage())
        }
    }, [message, dispatch]);

    if (isLoading) {
        return <Spinner />;
    }

    const canAccessNewWorker = subStatus === 'trialing' || subStatus === 'active';

    return (
        <>
            <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
                <div className="rounded-2xl border border-border bg-surface p-4 shadow-sm sm:p-5">
                    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                        <div className="relative w-full sm:max-w-lg">
                            <FiSearch className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-4" />
                            <input
                                type="text"
                                placeholder="Search by name or phone"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="h-10 w-full rounded-md border border-border bg-surface pl-10 pr-3 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40"
                            />
                        </div>
                        <div className="sm:ml-3">
                            <button
                                onClick={() => {
                                    if (canAccessNewWorker) {
                                        dispatch(reset());
                                        navigate('/new-worker');
                                    }
                                }}
                                disabled={!canAccessNewWorker}
                                className={`inline-flex h-10 items-center gap-2 rounded-md px-4 text-label font-medium transition ${
                                    canAccessNewWorker
                                        ? 'bg-ink text-white hover:bg-ink-2'
                                        : 'cursor-not-allowed bg-surface-2 text-ink-4'
                                }`}
                            >
                                <FiUserPlus className="h-4 w-4" />
                                <span>New Worker</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mx-auto max-w-7xl px-4 pb-6 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                    {filterWorkers(searchTerm).map((worker) => (
                        <WorkerItem key={worker.id} worker={worker} />
                    ))}
                </div>
            </div>
        </>
    );
}

export default Workers;
